export const PERMISSION_KEY_ADMIN = 'Admin';
export const PERMISSION_KEY_ADJUSTMENT = 'Adjustment';
export const PERMISSION_KEY_AUTHENTICATION_TOKEN = 'AuthenticationToken';
export const PERMISSION_KEY_BANK = 'Bank';
export const PERMISSION_KEY_CATEGORY = 'Category';
export const PERMISSION_KEY_CART = 'Cart';
export const PERMISSION_KEY_CONSIGNMENT = 'Consignment';
export const PERMISSION_KEY_CONSIGNMENT_SERVICE = 'ConsignmentService';
export const PERMISSION_KEY_COURIER_SERVICE = 'CourierService';
export const PERMISSION_KEY_DASHBOARD = 'Dashboard';
export const PERMISSION_KEY_DEPOSIT = 'Deposit';
export const PERMISSION_KEY_FULFILMENT = 'Fulfillment';
export const PERMISSION_KEY_INVENTORY = 'Inventory';
export const PERMISSION_KEY_LOCATION = 'Location';
export const PERMISSION_KEY_NOTIFICATION = 'Notification';
export const PERMISSION_KEY_OPTION_TYPE_TEMPLATE = 'OptionTypeTemplate';
export const PERMISSION_KEY_OPTION_VALUE_TEMPLATE = 'OptionValueTemplate';
export const PERMISSION_KEY_ORDER = 'Order';
export const PERMISSION_KEY_ORDER_CHECKPOINT = 'OrderCheckpoint';
export const PERMISSION_KEY_PAYMENT = 'Payment';
export const PERMISSION_KEY_PAYMENT_METHOD = 'PaymentMethod';
export const PERMISSION_KEY_PERMISSION = 'Permission';
export const PERMISSION_KEY_PRODUCT = 'Product';
export const PERMISSION_KEY_QUICK_LINK = 'QuickLink';
export const PERMISSION_KEY_REASON = 'Reason';
export const PERMISSION_KEY_RETURN_POLICY = 'ReturnPolicy';
export const PERMISSION_KEY_REVIEW = 'Review';
export const PERMISSION_KEY_ROLE = 'Role';
export const PERMISSION_KEY_REPORT = 'Report';
export const PERMISSION_KEY_SETTLEMENT = 'Settlement';
export const PERMISSION_KEY_SHIPPER = 'Shipper';
export const PERMISSION_KEY_SIZE = 'Size';
export const PERMISSION_KEY_STAT = 'Stat';
export const PERMISSION_KEY_STORE = 'Store';
export const PERMISSION_KEY_TENANT = 'Tenant';
export const PERMISSION_KEY_USER = 'User';
export const PERMISSION_KEY_WAREHOUSE = 'Warehouse';
export const PERMISSION_KEY_WARRANTY_TYPE = 'WarrantyType';
export const PERMISSION_KEY_LINE_ITEM = 'LineItem';
export const PERMISSION_KEY_RETURN = 'Return';
export const PERMISSION_KEY_RECORDINGS = 'Recording';
export const PERMISSION_KEY_ATTACHMENT = 'Attachment';
export const PERMISSION_KEY_TASK = 'Task';
export const PERMISSION_KEY_TODO = 'Todo';
export const PERMISSION_KEY_FOLLOW_UP = 'Followup';

export const ACTION_CHANGE_STATUS = 'change_status';
export const ACTION_MANAGE = 'manage';
export const ACTION_SIGN_UP = 'sign_up';
export const ACTION_INDEX = 'index';
export const ACTION_SALES_REPORT = 'sales_report';
export const ACTION_PROP_GO_QR_INFO = 'prop_go_qr_info';
export const ACTION_UPDATE = 'update';
export const ACTION_UPDATE_ADDRESS = 'update_address';
export const ACTION_SHARE = 'share';
export const ACTION_PREVIEW = 'preview';
export const ACTION_MARK_ACTIVE = 'mark_active';
export const ACTION_SHIPPING_CHARGES_OPTIONS = 'shipping_charges_options';
export const ACTION_CREATE = 'create';
export const ACTION_SHOW = 'show';
export const ACTION_DESTROY = 'destroy';
export const ACTION_DISPATCHED = 'dispatched';
export const ACTION_PAYMENT_SUBMITTED = 'payment_submitted';
export const ACTION_DELIVERED = 'delivered';
export const ACTION_RETURNED = 'returned';
export const ACTION_CANCELLED = 'cancelled';
export const ACTION_AWAITING_RIDER_COLLECTION = 'awaiting_rider_collection';
export const ACTION_PRINT_SHIPPING_LABEL = 'print_shipping_label';
export const ACTION_DOWNLOAD = 'download';
export const ACTION_TRACK_ORDER = 'track_order';
export const ACTION_PRINT_SHIPPING_LABELS = 'print_shipping_labels';
export const ACTION_CONFIRM_SHIPMENTS = 'confirm_shipments';
export const ACTION_VERIFY = 'verify';
export const ACTION_COLLECT = 'collect';
export const ACTION_TOTAL_DUE_AMOUNT = 'total_due_amount';
export const ACTION_MARK_AS_VERIFIED = 'mark_as_verified';
export const ACTION_PAYMENTS_IMPORT = 'payments_import';
export const ACTION_TRIGGER_WEBHOOK = 'trigger_webhook';
export const ACTION_CURRENT = 'current';
export const ACTION_RATINGS = 'ratings';
export const ACTION_PRODUCTS_RATINGS = 'products_ratings';
export const ACTION_ADD = 'add';
export const ACTION_TOGGLE_STATUS = 'toggle_status';
export const ACTION_UNITS = 'units';
export const ACTION_GROUPED = 'grouped';
export const ACTION_SORT = 'sort';
export const ACTION_CANCEL_ORDER = 'cancel_order';
export const ACTION_REMOVE_LINE_ITEM = 'remove_line_item';
export const ACTION_ACCEPT_ORDER = 'accept_order';
export const ACTION_CREATE_CONSIGNMENT = 'create_consignment';
export const ACTION_BY_WEIGHT_RANGE = 'by_weight_range';
export const ACTION_MISSING_CATEGORY_FIELD = 'missing_category_fields';
export const ACTION_ACCEPT_ORDERS = 'accept_orders';
export const ACTION_CONFIRM_PICKUP = 'confirm_pickup';
export const ACTION_CREATE_SHIPMENTS = 'create_shipments';
export const ACTION_ACCOUNT_STATEMENT = 'account_statement';
export const ACTION_ORDERS_SUMMARY = 'orders_summary';
export const ACTION_PRODUCTS_SUMMARY = 'products_summary';
export const ACTION_PAYMENTS_SUMMARY = 'payments_summary';
export const ACTION_LOAD_SHEET = 'load_sheet';
export const ACTION_RETRY_ONBOARD = 'retry_onboard';
export const ACTION_RESYNC_ONBOARD = 'resync_onboard';
export const ACTION_SEND_WELCOME_EMAIL = 'send_welcome_email';
export const ACTION_SETTLEMENTS_SHEET = 'settlements_sheet';
export const ACTION_PRODUCT_RATINGS = 'product_ratings';
export const ACTION_STORE_RATINGS = 'store_ratings';
export const ACTION_ORDER_TRENDS = 'orders_trends';
export const ACTION_SALES_TRENDS = 'sales_trends';
export const ACTION_ADD_COMMENT = 'add_comment';
export const ACTION_PRODUCT_STATS = 'product_stats';
export const ACTION_STATUSES = 'statuses';
export const ACTION_MARK_READ = 'mark_read';
export const ACTION_ORDERS = 'orders';
export const ACTION_ORDER_STATS = 'order_stats';
export const ACTION_REVIEWS = 'reviews';
export const ACTION_SELLERS = 'sellers';
export const ACTION_PRODUCTS = 'products';
export const ACTION_AVERAGE_SELLER_RATING = 'average_seller_ratings';
export const ACTION_SHIPMENTS = 'shipments';
export const ACTION_TRANSACTION_HISTORY = 'transaction_history';
export const MARK_SETTLED = 'mark_settled';
export const MARK_PAID = 'mark_paid';
export const ASSIGN_ROLE = 'assign_role';
export const ACTION_STORE_CATEGORIES = 'categories';
export const ACTION_CHAT_URL = 'chat_url';
export const ACTION_CATEGORY_FIELD_PRODUCTS = 'category_fields_products';
export const ACTION_MISSING_CATEGORY_FIELDS = 'missing_category_fields';
export const ACTION_CATEGORY_PRODUCTS = 'category_products';
export const ACTION_GROUPED_BY_WEIGHT_RANGE = 'grouped_by_weight_ranges';
export const ACTION_PUSH_CALL_NOTIFICATION = 'push_call_notification';
export const ACTION_FINANCE_SHEET = 'finance_sheet';
export const ACTION_PAYOUT_IMPORT = 'payout_import';
export const ACTION_REFUND_PAYMENT = 'refund';
export const ACTION_APPROVE_MODERATION = 'approve_moderation';
export const ACTION_REJECT_MODERATION = 'reject_moderation';
export const ACTION_AVERAGE_DELIVERY_TIME = 'average_delivery_time';
export const ACTION_CURRENT_DAY_ORDER = 'current_day_order_stats';
export const ACTION_LIFETIME_ORDER = 'lifetime_order_stats';
